import * as React from "react";

const Diente42 = (props) => {

  //"#fff"
  let color= '#fff';
  //---------------
  //if(props.pza === props.pieza ){    //si es true, lo cambiamos de color el diente
    color= props.color;
  //}
  return (
  <svg style={{ width: "inherit", height: "inherit" }}
          version="1.1"
          viewBox="0 0 13.818897 25.866141"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          {...props}
      >
   
   
   

     <g
      
      transform="translate(0,-1026.4961)"
    >
      <path
        fill= "#000"
          d="m 7.7321351,1026.5543 c 1.2895,0.3308 1.997,2.1153 2.5009089,3.193 0.647421,1.4485 2.312361,8.8462 3.142561,13.5516 0.52004,2.9475 0.12982,7.5073 -0.68686,8.5971 -2.6959301,0.8947 -8.9636103,0.6875 -10.9848603,0 -2.26923998,-1.0755 -1.26099998,-6.9319 -1.25608998,-8.3729 -0.26841,-2.1672 2.52208998,-13.895 3.87633998,-16.0313 1.1932,-1.303 2.45089,-0.9209 3.4080004,-0.9355 z m -2.7743504,1.5839 c -1.60056,3.4182 -3.7697,14.3543 -3.66411,15.5693 0.0559,0.643 -0.59643998,7.0143 0.87134,7.4254 0.77055,0.2128 7.5771404,0.8168 9.8810003,-0.01 0.51089,-0.1652 0.92443,-4.686 0.43876,-7.7965 -0.64268,-4.116 -1.72519,-9.9005 -2.8951699,-13.1836 -0.55927,-1.3982 -0.92943,-2.2414 -2.06205,-2.8174 -0.5723904,-0.1461 -2.2548104,-0.093 -2.5698004,0.8129 z m 5.1414103,13.4433 c -1.4045099,-0.9523 -1.0498099,-8.4391 -3.1017303,-8.6709 -1.41636,0.2457 -1.41245,6.2177 -2.17826,6.6111 -0.68323,-0.4619 0.4427,-7.7651 2.17523,-8 2.4612904,0.4376 3.4347203,9.7821 3.1047603,10.0598 z"
      />
      <path
      fill={color}
      stroke="#000"
      strokeWidth={0.012}
      d="m 6.5132935,1027.312 c -2.3224282,0.1766 -2.25746,3.2563 -2.9885046,4.8235 -1.5252554,5.9212 -3.04689626,12.1554 -2.0566626,18.274 0.8186529,1.805 3.3934243,0.8795 4.9393519,1.1575 1.8802763,-0.1668 4.0187778,0.2634 5.7679268,-0.4254 0.706116,-2.9634 0.280845,-6.1474 0.134038,-9.1769 -0.817773,-4.527 -1.429694,-9.2502 -3.4810224,-13.4279 -0.4588681,-0.8182 -1.3390506,-1.3868 -2.3151271,-1.2248 z m 0.5015069,4.207 c 1.8731097,0.7353 2.0213256,3.2797 2.5889608,4.922 0.1707007,1.6323 1.1715918,3.5123 0.5015068,5.0957 -1.0667495,-1.092 -0.8987416,-3.1031 -1.328155,-4.548 -0.4353064,-1.2861 -0.4366734,-3.1331 -1.6385384,-3.9667 -1.2550777,0.2472 -1.0649994,2.1367 -1.4519189,3.0735 -0.3249858,0.9581 -0.305339,2.8374 -1.0735543,3.3208 -0.1178085,-2.6077 0.1918493,-5.6538 1.9284144,-7.7229 0.1272436,-0.097 0.2999949,-0.1778 0.4732846,-0.1744 z"
    />
    </g>



    
    
  
  </svg>
)}
export default Diente42;